
export const config = {
    apiKey: "AIzaSyA32cpHGqsZoZvkAj50_j37Dgq8MA_h-Fc",
    authDomain:"gardenserver-d4079.firebaseapp.com",
    databaseURL: "https://gardenserver-d4079.firebaseio.com",
    projectId: "gardenserver-d4079",
    storageBucket: "gardenserver-d4079.appspot.com",
    messagingSenderId: "369780170146",
    appId: "1:369780170146:web:5d2aaa1bcae434a4cfa6fb",
    measurementId: "G-WHK1590S2S"
  };
  